import React from 'react'

import { Button, Empty, Skeleton, Icon, Tag } from 'antd'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import moment from 'moment'

import './styles.scss'

class DownloadInvoice extends React.Component {
  constructor(props) {
    super(props)

    this.state = { files: [], downloadUrl: null, loading: false, error: false }
  }

  loadData = (selectedCloud, billingBucket) => {
    this.setState({ loading: true })
    CloudFlyerAPI.storages
      .getFilesByPath(`${selectedCloud}/${billingBucket}`, '/', 100)
      .then(({ data }) => {
        this.setState({ files: data.items, loading: false })
      })
      .catch(() => this.setState({ files: [], loading: false, error: true }))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedCloud, billingBucket } = nextProps
    if (
      selectedCloud &&
      selectedCloud !== this.props.selectedCloud &&
      billingBucket
    ) {
      this.loadData(selectedCloud, billingBucket)
    }
  }

  componentDidMount() {
    const { selectedCloud, billingBucket } = this.props
    if (selectedCloud && billingBucket) {
      this.loadData(selectedCloud, billingBucket)
    }
  }

  downloadFile = fileName => {
    const { selectedCloud, billingBucket } = this.props
    CloudFlyerAPI.transfer
      .download_url(selectedCloud, billingBucket, [fileName])
      .then(({ data }) => {
        this.setState({ downloadUrl: data[0]['url'] })
      })
  }

  render() {
    const { files, downloadUrl, loading, error } = this.state
    return (
      <div className="download-invoice">
        {downloadUrl && (
          <iframe
            style={{ display: 'none' }}
            download={downloadUrl}
            src={downloadUrl}
          />
        )}
        <Files
          files={files}
          onDownload={this.downloadFile}
          loading={loading}
          error={error}
        />
        <div className="reports">
          <a
            target="_blank"
            href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/DetailedBillingReport.html"
          >
            Detailed Billing Report
          </a>
          <a
            target="_blank"
            href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/reportstagsresources.html"
          >
            Detailed Billing Report With Resources and Tags
          </a>
          <a
            target="_blank"
            href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/monthly-report.html"
          >
            Monthly Report
          </a>
          <a
            target="_blank"
            href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/reportwithtags.html"
          >
            Monthly Cost Allocation Report
          </a>
        </div>
      </div>
    )
  }
}

const Files = ({ files, onDownload, loading, error }) => (
  <div className="files">
    {error ? (
      <div className="error">
        <Icon type="frown" /> <div>Could not load data.</div>
      </div>
    ) : loading ? (
      <Skeleton title={false} paragraph={{ rows: 16, width: '100%' }} active />
    ) : files.length ? (
      files.map(f => (
        <File basename={f.basename} mtime={f.mtime} onDownload={onDownload} />
      ))
    ) : (
      <Empty />
    )}
  </div>
)

const File = ({ basename, mtime, onDownload }) => (
  <div className="file">
    <div className="left-side">
      <div className="date">
        <Tag color="grey">{moment(mtime).format('MMM - Do')}</Tag>
      </div>
      <div className="name">{basename}</div>
    </div>
    <div className="download-btn">
      <Button
        shape="circle"
        icon="download"
        onClick={() => onDownload(basename)}
      />
    </div>
  </div>
)

export default DownloadInvoice
